import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NotificationTemplate {
  code: string;
  name: string;
  description: string;
  email?: {
    subject: string;
    body: string;
  };
  sms?: {
    body: string;
  };
  whatsapp?: {
    body: string;
  };
}

export interface SendNotificationPayload {
  templateCode: string;
  channels: string; 
  recipient: string;
  variables: Record<string, any>;
}

export interface NotificationLog {
  id?: string;
  templateCode: string;
  channel: string;
  recipient: string;
  status: 'sent' | 'failed' | 'pending';
  sentAt?: Date;
  error?: string;
}

@Injectable({
  providedIn: 'root'
})
export class EmailSttingsService {
  private apiUrl = environment.apiUrl + '/notifications'; // Update with your API endpoint

  constructor(private http: HttpClient) { }

  createOrUpdateTemplate(template: NotificationTemplate): Observable<any> {
    return this.http.post(`${this.apiUrl}/templates`, template);
  }

  getTemplates(): Observable<any> {
    return this.http.get(`${this.apiUrl}/templates`);
  }

  getTemplateByCode(code: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/templates/${code}`);
  }

  sendNotification(payload: SendNotificationPayload): Observable<any> {
    return this.http.post(`${this.apiUrl}/send`, payload);
  }

  // getNotificationLogs(filters?: {
  //   templateCode?: string;
  //   channel?: string;
  //   status?: string;
  //   startDate?: Date;
  //   endDate?: Date;
  // }): Observable<any> {
  //   let url = `${this.apiUrl}/logs`;
  //   if (filters) {
  //     const params = new URLSearchParams();
  //     if (filters.templateCode) params.append('templateCode', filters.templateCode);
  //     if (filters.channel) params.append('channel', filters.channel);
  //     if (filters.status) params.append('status', filters.status);
  //     if (filters.startDate) params.append('startDate', filters.startDate.toString());
  //     if (filters.endDate) params.append('endDate', filters.endDate.toString());

  //     const queryString = params.toString();
  //     if (queryString) {
  //       url += '?' + queryString;
  //     }
  //   }
  //   return this.http.get(url);
  // }

  getNotificationLogs(filters: any) {
    let params = new HttpParams();
  
    Object.keys(filters).forEach(key => {
      const value = filters[key];
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value);
      }
    });
  
    return this.http.get(`${this.apiUrl}/logs`, { params });
  }

  deleteTemplate(code: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/templates/${code}`);
  }

  parseVariables(content: string): string[] {
    const regex = /\{\{(\w+)\}\}/g;
    const variables: string[] = [];
    let match;

    while ((match = regex.exec(content)) !== null) {
      if (!variables.includes(match[1])) {
        variables.push(match[1]);
      }
    }

    return variables;
  }

  substituteVariables(content: string, variables: Record<string, any>): string {
    let result = content;
    Object.keys(variables).forEach(key => {
      const regex = new RegExp(`\\{\\{${key}\\}\\}`, 'g');
      result = result.replace(regex, variables[key]);
    });
    return result;
  }
}
